import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";

/**
 * @purpose See at a glance what needs my attention at my locations and jump to it
 * @primary Role-specific welcome dashboard (admin / manager / hotel staff views)
 * @persona sports-manager-ikos, paola-admin-belora, staff-ikos, mecanico-externo
 */
export const Route = createFileRoute("/app/$customer/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
});
